// @flow

import React from "react";
import { View } from "react-native";
import { confirmedOrderStyles as styles } from "./styles";
import { useTranslateText } from "@/app/utils";
import { TouchableOpacity } from "@/app/components/Buttons";
import { Text } from "@/app/components/Text";
import { Order } from "@/app/types/order";
import { withForwardRef } from "@/app/utils/withForwardRef";

type ConfirmedOrderProps = {
  onNewOrderPress: () => void;
  order: Order;
};

const ConfirmedOrder = ({
  onNewOrderPress,
  order,
}: ConfirmedOrderProps): JSX.Element => {
  const { t } = useTranslateText();
  const lane = order?.lane?.name;
  const pin = order?.backupPin;
  const orderIdentifier = order?.albaikIdentifier;

  let header = lane
    ? t("tpos.orderArea.placedOrder.lane", { lane })
    : t("tpos.orderArea.placedOrder.noLane");
  let description = lane
    ? t("tpos.orderArea.placedOrder.placedOrderText")
    : t("tpos.orderArea.placedOrder.noLanePlacedOrderText");

  return (
    <View style={styles.container}>
      <Text style={styles.confirmOrderHeader}>{header}</Text>
      <Text style={styles.confirmOrderText}>{description}</Text>
      <View style={styles.orderInfoSection}>
        <Text style={styles.confirmOrderHeader}>#{orderIdentifier}</Text>
        <Text style={styles.confirmOrderHeader}>
          {t("tpos.orderHistoryArea.pin")}
          {pin}
        </Text>
      </View>
      <View style={styles.buttonContainer}>
        <View style={styles.newOrderContainer}>
          <TouchableOpacity
            onPress={onNewOrderPress}
            style={styles.newOrderButton}
          >
            <Text style={styles.newOrder}>
              {t("tpos.orderArea.placedOrder.newOrder")}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default withForwardRef<HTMLDivElement, ConfirmedOrderProps>(
  ConfirmedOrder,
);
